'use client';

import React, { PropsWithChildren, Suspense, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { pathnameToKind } from '@/constants/home-feed';

import { ScrollArea } from '@repo/ui/components/ui/scroll-area';

import { HOME_TAB } from '@/@types/enums';
import { useAppTabs } from '@/providers/app-tabs-provider';
import { AppHeader } from '@/components/layout/app-header';
import { YouTubeAnalysisIndicator } from '@/components/youtube-analysis-indicator';

const InnerAppLayoutWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const pathname = usePathname();
  const { setHomeTab } = useAppTabs();

  // Feed kind is the ROUTE (`/home` all, `/youtube` videos, `/articles`
  // news). This only picks the app navigator's mode: channel pages list
  // channels, everything else lists brands.
  useEffect(() => {
    setHomeTab(
      pathnameToKind(pathname) === 'videos' ? HOME_TAB.YOUTUBE : HOME_TAB.NEWS,
    );
  }, [pathname, setHomeTab]);

  return (
    <div
      id="cred-app-main-container"
      aria-label="Skim webapp in iframe"
      className="dark flex max-h-screen w-full max-w-75.25 flex-1 overflow-hidden border-l border-foreground bg-[#F0F2F5] font-roboto shadow-md cred-md:max-w-87.75 cred-lg:max-w-95.25 cred-xl:max-w-125.25"
    >
      <ScrollArea className="dark flex size-full flex-col">
        <div className="relative flex size-full min-h-screen flex-col">
          <AppHeader />
          <YouTubeAnalysisIndicator />
          <main className="flex size-full flex-1 flex-col">{children}</main>
        </div>
      </ScrollArea>
    </div>
  );
};

export const AppLayoutWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Suspense fallback={<></>}>
      <InnerAppLayoutWrapper>{children}</InnerAppLayoutWrapper>
    </Suspense>
  );
};
